/**
 * Central date formatting utility.
 * Always uses Gregorian calendar (ca-gregory) + Latin numerals (nu-latn)
 * to avoid Hijri calendar output on ar-SA locale.
 * Output example: "10 مارس 2026"
 */

const LOCALE = 'ar-SA-u-ca-gregory-nu-latn';

/**
 * "10 مارس 2026"
 */
export const formatDate = (dateStr, fallback = '—') => {
  if (!dateStr) return fallback;
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return fallback;
    return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
  } catch { return fallback; }
};

/**
 * "الثلاثاء، 10 مارس 2026"
 */
export const formatDateWithWeekday = (dateStr, fallback = '—') => {
  if (!dateStr) return fallback;
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return fallback;
    return d.toLocaleDateString(LOCALE, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  } catch { return fallback; }
};

/**
 * "10 مارس 2026 - 2:30 م"
 */
export const formatDateTime = (dateStr, fallback = '—') => {
  if (!dateStr) return fallback;
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return fallback;
    const date = d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
    const time = d.toLocaleTimeString('ar-SA', { hour: 'numeric', minute: '2-digit', hour12: true });
    return `${date} - ${time}`;
  } catch { return fallback; }
};

/**
 * "10 مار 2026" — short month
 */
export const formatDateShort = (dateStr, fallback = '—') => {
  if (!dateStr) return fallback;
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return fallback;
    return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' });
  } catch { return fallback; }
};

/**
 * "2:30 م" / "10:00 ص" — تحويل وقت 24 ساعة إلى 12 ساعة بـ ص/م
 * @param {string} time - HH:MM or HH:MM:SS
 * @param {string} fallback
 */
export const formatTimeToArabic = (time, fallback = 'غير محدد') => {
  if (!time) return fallback;
  if (typeof time === 'string' && (time.includes('ص') || time.includes('م'))) return time;
  const [hours, minutes] = String(time).split(':');
  const hour = parseInt(hours, 10);
  const min  = minutes || '00';
  if (isNaN(hour)) return time;
  if (hour === 0)  return `12:${min} ص`;
  if (hour < 12)   return `${hour}:${min} ص`;
  if (hour === 12) return `12:${min} م`;
  return `${hour - 12}:${min} م`;
};

/**
 * "10 مارس" — day + month only (for activity feeds, notifications)
 */
export const formatDateNoYear = (dateStr, fallback = '—') => {
  if (!dateStr) return fallback;
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return fallback;
    return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long' });
  } catch { return fallback; }
};
